module.exports = __webpack_public_path__ + "img/new-logo-header.7962b4d0.png";